var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAmericanSamoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7623 2.007C21.4633 0.729 18.8169 0 16 0C7.16413 0 0.001125 7.16238 0 15.9981L11.1304 10.4348L23.7623 2.007Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.002C0.001125 24.8377 7.16413 32.0001 16 32.0001C18.8169 32.0001 21.4633 31.2712 23.7623 29.9931L11.1304 21.5653L0 16.002Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0956 2.83645C24.6659 2.53901 24.2206 2.26239 23.7617 2.00732L0 15.9982V16.0001C0 16.0001 0 16.0014 0 16.0019L23.7617 29.9928C24.2206 29.7376 24.6659 29.4611 25.0957 29.1636L2.73887 16.0001L25.0956 2.83645Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8261 15.4034H25.9202C26.4158 14.8084 26.3852 13.9232 25.8269 13.365C26.4183 12.7737 26.4183 11.8149 25.8269 11.2235L25.7913 11.2592C26.3826 10.6679 26.4183 9.67334 25.8269 9.08203L17.2609 17.648C17.8523 18.2395 18.7943 18.2324 19.3856 17.641L19.5504 17.4903L23.6522 17.1175V18.8816H25.0435V16.991L27.1304 16.8013L27.8261 15.4034Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3918 19.4782L16 18.7826L17.3918 18.0869H26.4352V19.4782H17.3918Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAmericanSamoa);
export default __webpack_public_path__ + "static/media/flag_american_samoa.54dcfcd494a826c640e3ebb6a5931e65.svg";
export { ForwardRef as ReactComponent };